import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * The reCAPTCHA Enterprise badge is loaded globally (App Check), but it should
 * only be visible on the pages where reCAPTCHA actually runs — the auth pages.
 * This toggles a `show-recaptcha` class on <body> on those routes; index.css
 * hides the badge everywhere else. Renders nothing.
 */
const AUTH_PATH_PREFIXES = [
  "/login",
  "/phone-login",
  "/signup",
  "/register",
  "/token-login",
  "/forgot-password",
  "/reset-password",
];

const RecaptchaBadgeVisibility: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const onAuthPage = AUTH_PATH_PREFIXES.some(
      (p) => pathname === p || pathname.startsWith(p + "/")
    );
    document.body.classList.toggle("show-recaptcha", onAuthPage);
    return () => {
      // Leave the class as the next route sets it; no cleanup needed beyond the toggle.
    };
  }, [pathname]);

  return null;
};

export default RecaptchaBadgeVisibility;
